import BaseApi from '@/api/Base/BaseApi'
import {
  CreateModelRetrainNodeFromDqiPayload,
  CreateModelRetrainNodeFromModelDriftPayload,
  GetModelRetrainNodeDetailResponse,
  GetReferenceNodesPipelineInfoResponse,
  UpdateModelRetrainNodePayload,
  ModelRetrainExportPayload,
  ReplaceDriftReferencePayload,
  GetModelRetrainNodeListPayload
} from '@/api/ModelRetrainNode/types'
import {
  CommonValidationResult,
  GetValidationResultItemsResponse,
  ValidationResultItemsPayload
} from '@/api/ValidationNode/types'

const ROOT = '/model-retrain'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'asc',
  sortKey: 'datasetItemId',
}

export default class ModelRetrainNodeApi extends BaseApi {
  createModelRetrainNodeFromDqi(payload: CreateModelRetrainNodeFromDqiPayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create`, rest)
  }

  createModelRetrainNodeFromModelDrift(payload: CreateModelRetrainNodeFromModelDriftPayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create/model-drift`, rest)
  }

  updateModelRetrainNode(payload: UpdateModelRetrainNodePayload) {
    const { modelRetrainNodeId, name, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainNodeId}`, { ...rest, name: name?.trim() })
  }

  exportModelRetrain(payload: ModelRetrainExportPayload) {
    const { modelRetrainNodeId, ...rest } = payload
    return this.agent.post(`${ROOT}/${modelRetrainNodeId}/export`, rest)
  }

  getModelRetrainNodeDetail(modelRetrainNodeId: string) {
    return this.agent.get<GetModelRetrainNodeDetailResponse>(`${ROOT}/${modelRetrainNodeId}`)
  }

  getReferenceNodesPipelineInfo(modelRetrainNodeId: string) {
    return this.agent.get<GetReferenceNodesPipelineInfoResponse>(`${ROOT}/${modelRetrainNodeId}/pipeline`)
  }

  replaceDriftReference(payload: ReplaceDriftReferencePayload) {
    const { modelRetrainNodeId } = payload
    return this.agent.post(`${ROOT}/${modelRetrainNodeId}/replace-drift-reference`)
  }

  getModelRetrainNodeList(payload: GetModelRetrainNodeListPayload) {
    const { projectId, ...rest } = payload
    return this.agent.get<GetModelRetrainNodeDetailResponse[]>(`project/${projectId}/model-retrain-list`, { params: rest })
  }

  getRetrainResultSummary(modelRetrainNodeId: string) {
    return this.agent.get<CommonValidationResult>(`${ROOT}/${modelRetrainNodeId}/summary`)
  }

  getRetrainResultItems(modelRetrainNodeId: string, options?: ValidationResultItemsPayload) {
    const normalizedOptions: ValidationResultItemsPayload = options ?? {}
    const {
      itemsPerPage = defaultPaginationOptions.itemsPerPage,
      page = defaultPaginationOptions.page,
      sortDir = defaultPaginationOptions.sortDir,
      sortKey = defaultPaginationOptions.sortKey,
      isNG,
      includeDetectedObjects,
      filterClassIds,
      isMatched,
      hasMissed,
      hasOverDetected,
      hasNoPredictedClass,
      keyword,
    } = normalizedOptions
    return this.agent.get<GetValidationResultItemsResponse>(`${ROOT}/${modelRetrainNodeId}/result-items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
        isNG,
        includeDetectedObjects,
        filterClassIds,
        isMatched,
        hasMissed,
        hasOverDetected,
        hasNoPredictedClass,
        // 파일명 부분 일치 검색
        keyword,
      },
    })
  }

  // downloadModelRetrain(payload: any) {
  //   const { aiJobId, ...rest } = payload
  //   return this.agent.post(`${ROOT}/${aiJobId}/download`, rest)
  // }
}
